import { isDefined } from './isDefined';

export default function compareRolesInArray(userRole = {}, rolesArray = []) {
  const { name: userRoleName } = userRole;
  
  const hasUserRole = rolesArray.find(role => role === userRoleName);

  return isDefined(hasUserRole);
}
